// Gift Reggie registry and wishlist pages (the gr_v2 and gr_owner_v2 markup in the app's templates).
// Each card's form adds its product to the cart drawer, the share button opens the share sheet or
// copies the link, and on the owner's registry list changes show a bar to save them. Listeners sit
// on the document, since the app renders the markup.
(function () {
  const list = document.querySelector('.gr[data-max-pages]');
  // The app pages registries 25 items at a time; one page keeps needed and bought items together
  if (list && Number(list.dataset.maxPages) > 1 && !/[?&]limit=/.test(window.location.search)) {
    const url = new URL(window.location.href);
    url.searchParams.set('limit', '100');
    window.location.replace(url);
    return;
  }

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('.gr-card__form');
    if (!form) return;
    const cart = document.querySelector('cart-drawer');
    if (!cart) return;
    event.preventDefault();

    const button = form.querySelector('.gr-card__add');
    const error = form.querySelector('.gr-card__error');
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    error.hidden = true;

    const formData = new FormData(form);
    formData.append(
      'sections',
      cart.getSectionsToRender().map((section) => section.id)
    );
    formData.append('sections_url', window.location.pathname);
    cart.setActiveElement(button);

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = formData;

    fetch(window.routes.cart_add_url, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          error.textContent = response.description || response.message;
          error.hidden = false;
          return;
        }
        cart.classList.remove('is-empty');
        cart.renderContents(response);
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'gift-registry', cartData: response });
      })
      .catch((e) => {
        console.error(e);
        form.submit();
      })
      .finally(() => {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      });
  });

  // Copies the link and says so on the button for a few seconds
  function copy(button, name) {
    navigator.clipboard?.writeText(button.dataset.url).then(() => {
      const label = button.querySelector(`.${name}__label`);
      const done = button.querySelector(`.${name}__done`);
      label.hidden = true;
      done.hidden = false;
      setTimeout(() => {
        label.hidden = false;
        done.hidden = true;
      }, 3000);
    });
  }

  document.addEventListener('click', (event) => {
    const share = event.target.closest('.gr-share');
    if (share) {
      const { url, title } = share.dataset;
      if (navigator.share) navigator.share({ title, url }).catch(() => {});
      else copy(share, 'gr-share');
      return;
    }
    const copyButton = event.target.closest('.gr-copy');
    if (copyButton) copy(copyButton, 'gr-copy');
  });

  // Removing asks first; the button posts the app's own remove action
  document.addEventListener('click', (event) => {
    const remove = event.target.closest('.gr-row__remove, .gr-card__remove');
    if (remove && !window.confirm(`Fjarlægja ${remove.dataset.title} af listanum?`)) event.preventDefault();
  });

  // An empty registry offers the owner's wishlist: the panel shows when the wishlist has products, and
  // the button adds each with quantity 1 through the app's API (GiftReggie, from the app's page header).
  // The registry takes Shopify product ids, which the wishlist may only give as a handle.
  const copyPanel = document.querySelector('.gr-copy-wishlist');
  if (copyPanel && window.GiftReggie) {
    const call = (deferred) => new Promise((resolve, reject) => deferred.done(resolve).fail(reject));
    const { registryId, customerId, customerEmail, customerSecret } = copyPanel.dataset;
    const button = copyPanel.querySelector('.gr-copy-wishlist__button');
    const status = copyPanel.querySelector('.gr-copy-wishlist__status');
    const one = (n) => n % 10 === 1 && n % 100 !== 11;
    // "1 vöru", "3 vörur"; and as the subject, "1 vara", "3 vörur"
    const items = (n) => `${n} ${one(n) ? 'vöru' : 'vörur'}`;
    const itemsSubject = (n) => `${n} ${one(n) ? 'vara er komin' : 'vörur eru komnar'}`;
    const productId = async (product) => {
      const id = product.product_id || product.shopify_product_id;
      if (id) return id;
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}products/${product.handle}.js`);
      return response.ok ? (await response.json()).id : null;
    };

    let session;
    let products = [];
    call(GiftReggie.getSession(customerId, customerEmail, customerSecret))
      .then((result) => {
        session = result;
        return call(session.getWishlist());
      })
      .then((data) => {
        products = (data?.wishlist?.products || []).filter((product) => product.variant_id);
        if (!products.length) return;
        button.textContent = `Afrita ${items(products.length)} af óskalistanum`;
        copyPanel.hidden = false;
        // The panel stands in for the empty list's message
        const empty = copyPanel.parentElement.querySelector('.gr-empty');
        if (empty) empty.hidden = true;
      })
      .catch((e) => console.error(e));

    button.addEventListener('click', async () => {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      let copied = 0;
      for (const product of products) {
        try {
          const id = await productId(product);
          if (!id) continue;
          await call(session.addRegistryProducts(registryId, id, product.variant_id, 1, {}));
          copied++;
        } catch (e) {
          console.error(e);
        }
      }
      button.removeAttribute('aria-busy');
      status.hidden = false;
      if (!copied) {
        status.textContent = 'Það tókst ekki að afrita. Reyndu aftur eftir smá stund.';
        button.disabled = false;
        return;
      }
      // The app draws the list, so the page reloads to show it; when some failed, the owner reads that
      // first and reloads with the link
      const missed = products.length - copied;
      if (!missed) {
        status.textContent = `${itemsSubject(copied)} á listann. Augnablik…`;
        window.location.reload();
        return;
      }
      status.textContent = `${itemsSubject(copied)} á listann. Ekki tókst að afrita ${items(missed)}. `;
      const show = document.createElement('a');
      show.className = 'link';
      show.href = window.location.href;
      show.textContent = 'Sýna listann';
      status.append(show);
    });
  }

  // The owner's registry list
  const manage = document.querySelector('.gr-manage');
  if (!manage) return;
  const savebar = manage.querySelector('.gr-savebar');

  const changed = () =>
    [...manage.querySelectorAll('.quantity__input')].some((input) => input.value !== input.dataset.initial);
  const update = () => (savebar.hidden = !changed());
  manage.addEventListener('input', update);
  manage.addEventListener('change', update);
  // Dawn's quantity buttons set the value without an input event
  manage.addEventListener('click', (event) => {
    if (event.target.closest('.quantity__button')) setTimeout(update);
  });

  manage.querySelector('.gr-savebar__discard').addEventListener('click', () => {
    manage.querySelectorAll('.quantity__input').forEach((input) => (input.value = input.dataset.initial));
    update();
  });

  // Enter in a quantity saves, as in the app's table
  manage.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' || !event.target.matches('.quantity__input')) return;
    event.preventDefault();
    manage.querySelector('.gr-savebar__save').click();
  });

  // Leaving with unsaved changes asks first
  let submitting = false;
  manage.addEventListener('submit', () => (submitting = true));
  window.addEventListener('beforeunload', (event) => {
    if (!submitting && changed()) event.preventDefault();
  });

  manage.querySelectorAll('.gr-filter__option').forEach((option) =>
    option.addEventListener('click', () => {
      manage
        .querySelectorAll('.gr-filter__option')
        .forEach((other) => other.setAttribute('aria-pressed', other === option));
      manage.querySelectorAll('.gr-row').forEach((row) => {
        row.hidden = option.dataset.filter !== 'all' && row.dataset.state !== option.dataset.filter;
      });
    })
  );
})();
